import React from 'react'
import styled from 'styled-components'
import { Col, Container, Line } from '../components'
import { useTranslation } from 'react-i18next'

const Outer = styled.div`
  width: 100vw;
  padding: 40px 0;
  text-align: center;
  h4 {
    font-size: 45px;
    font-weight: 900;
    line-height: 1.2;
    color: #4d6478;
  }
  margin-top: 120px;

  @media (max-width: 768px) {
    padding: 20px 0;
    margin-top: 80px;

    h4 {
      font-size: 28px;
    }
  }
`

const Title = styled.h1`
  color: #b19961;
  font-size: 100px;
  margin: 0;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 48px;
  }
`

const Text = styled.p`
  font-weight: 300;
  font-size: 80px;
  margin: 0 0 0 10px;
  color: #363535;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

const Text2 = styled.p`
  font-weight: 300;
  font-size: 20px;
  margin: 0px 20px;
  color: #363535;

  @media (max-width: 768px) {
    font-size: 16px;
    
  }
`

const Heading = styled.p`
  font-weight: 400;
  font-size: 25px;
  margin: 15px 20px;
  color: #b19961;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 10px;
  }
`

const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1500px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    max-width: 100%;
    flex-direction: column;
    align-items: center;
  }
`

const Box = styled.div`
  position: relative;
  height: 550px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${require('assets/startline.jpeg')});
    background-size: cover;
    background-position: center;
    opacity: 0.7;
    z-index: -1;
  }

  @media (max-width: 768px) {
    height: 300px;
  }
`

const WhyWinner = () => {
  const { t } = useTranslation()
  return (
    <Container id='whyWinner'>
      <Line/>
      <BoxWrapper>
        <Box>
          <Outer>
            <Title>{t('whyWinner.why')}</Title>
            <Text>{t('whyWinner.whyWinner')}</Text>
          </Outer>
        </Box>
      </BoxWrapper>
      <Line/>
      <Col>
        <Col>
          <Heading>{t('whyWinner.Title1')} </Heading>
          <Text2>{t('whyWinner.Content1')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title2')} </Heading>
          <Text2>{t('whyWinner.Content2')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title3')} </Heading>
          <Text2>{t('whyWinner.Content3')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title4')} </Heading>
          <Text2>{t('whyWinner.Content4')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title5')} </Heading>
          <Text2>{t('whyWinner.Content5')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title6')} </Heading>
          <Text2>{t('whyWinner.Content6')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title7')} </Heading>
          <Text2>{t('whyWinner.Content7')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title8')} </Heading>
          <Text2>{t('whyWinner.Content8')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title9')} </Heading>
          <Text2>{t('whyWinner.Content9')} </Text2>
        </Col>
        <Col>
          <Heading>{t('whyWinner.Title10')} </Heading>
          <Text2>{t('whyWinner.Content10')} </Text2>
        </Col>
      </Col>
    </Container>
  )
}

export default WhyWinner
